/* eslint-disable @stripe-internal/stripe/no-mixed-react-exports */
import {PropsWithChildren, createContext} from 'react';
import {PageMetadata} from 'mkt-ssr/lib/page/metadata/types';
import {useRequiredContext} from 'mkt-ssr/lib/contextHelpers';
import type {RuntimePageConfig} from 'mkt-ssr/lib/page/PageConfig';

type PageMetadataWithConfig = PageMetadata & RuntimePageConfig;

const PageMetadataContext = createContext<PageMetadataWithConfig | undefined>(
  undefined,
);

export function usePageMetadata(): PageMetadataWithConfig {
  return useRequiredContext(PageMetadataContext);
}

export function PageMetadataProvider({
  metadata,
  children,
}: PropsWithChildren<{metadata: PageMetadataWithConfig}>) {
  return (
    <PageMetadataContext.Provider value={metadata}>
      {children}
    </PageMetadataContext.Provider>
  );
}
